<template>
  <v-list class="pa-0" color="transparent">
    <!-- Title -->
    <div class="text-subtitle-1 font-weight-bold mb-1">
      {{ title }}
    </div>

    <template v-for="(benefit, index) in benefits">
      <v-list-item
        :key="index"
        dense
        class="px-2"
      >
        <v-list-item-icon class="mr-5">
          <v-icon color="green accent-3">mdi-check-circle</v-icon>
        </v-list-item-icon>

        <v-list-item-content class="py-1">
          <div v-html="benefit" class="text-subtitle-1 font-weight-regular"></div>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-list>
</template>

<script>
export default {
  name: 'ProductBenefits',
  props: {
    title: {
      type: String,
      default() {
        return this.$translate('CHARACTERISTICS');
      },
    },
    benefits: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
